import { explicitMaybe, stringLiteral } from '@execonline-inc/decoders';
import { Decoder, array, dateISO, field, number, string, succeed } from 'jsonous';
import { participantsResourceDecoder } from '../../../../ParticipantsStore/Decoders';
import { resourceDecoder } from '../../../../Resource/Decoders';
import { GroupParticipants, GroupParticipantsResource } from './Types';

const groupParticipantsDecoder: Decoder<GroupParticipants> = succeed({})
  .assign('kind', field('kind', stringLiteral('group-participants')))
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('updatedAt', field('updated_at', dateISO))
  .assign('status', field('status', string))
  .assign('lastLoginAt', field('last_login_at', explicitMaybe(dateISO)))
  .assign('participants', field('participants', participantsResourceDecoder))
  .assign('totalParticipantsCount', field('total_participants_count', number))
  .assign('allParticipantIds', field('all_participant_ids', array(number)))
  .assign('activatedLicenseCount', field('activated_license_count', number));

export const groupParticipantsResourceDecoder: Decoder<GroupParticipantsResource> =
  resourceDecoder(groupParticipantsDecoder);
